import { createAction, props } from "@ngrx/store";
import { IVessel, IVesselOrientation } from "../model";
import { IQueryResult } from "@pmis3/data-access";

export enum VesselActionTypes {
    LoadVessels = "[VesselVisit Page] Load Vessels",
    LoadVesselsSuccess = "[VesselVisit Page] Load Vessels Success",
    LoadVesselsFail = "[VesselVisit Page] Load Vessels Fail",
    LoadVesselOrientations = "[VesselVisit Page] Load vessel orientations",
}

export const LoadVessels = createAction(
    VesselActionTypes.LoadVessels
)

export const LoadVesselsSuccess = createAction(
  VesselActionTypes.LoadVesselsSuccess,
  props<{result: IVessel[]}>()
);

export const LoadVesselsFail = createAction(
  VesselActionTypes.LoadVesselsFail,
  props<{ error: string }>()
);

export const LoadVesselOrientations = createAction(
  VesselActionTypes.LoadVesselOrientations,
  props<{ vesselOrientations: IVesselOrientation[]}>()
)